<template>
    <table class="mt-2 table table-sm table-bordered" style="list-style: none">
        <thead>
        <th class="px-2" v-text="__('Description')"></th>
        <th class="px-2 text-right"></th>
        </thead>
        <tbody>
        <tr v-for="item in items">
            <td class="px-2" v-text="item.description"></td>
            <td class="px-2 text-right" v-text="centsToMoneyFormat(item.fee)"></td>
        </tr>
        </tbody>
        <tfoot>
        <th class="px-2">Total</th>
        <th class="px-2 text-right" v-text="centsToMoneyFormat(amount)"></th>
        </tfoot>
    </table>
</template>
<script>
export default {
    props:{
        payment:{
            type: Object,
            required: true,
        }
    },

    data(){
        return {
            amount: this.payment.amount,
            items: this.payment.items,
        }
    },

    watch:{
        payment(){
            this.amount = this.payment.amount;
            this.items = this.payment.items;
        }
    }
}
</script>
